module.exports = __webpack_public_path__ + "img/trip_sendai07.b7cfc97c.jpg";